export const ready = (callback) => {
	if (document.readyState != 'loading') callback();
	else document.addEventListener('DOMContentLoaded', callback);
};

export const toggleClass = (el, className) => el.classList.toggle(className);

export const slide = ({e, parentSelector, contentSelector}) => {
	const CLASS_NAME_OPENED = 'opened';
	const CLASS_NAME_ANIMATED = 'animated';
	const parent = e.currentTarget.closest(parentSelector);
	const isAnimated = parent.classList.contains(CLASS_NAME_ANIMATED);

	if (isAnimated) return;

	parent.classList.add(CLASS_NAME_ANIMATED);

	const content = parent.querySelector(contentSelector);
	const isOpened = parent.classList.contains(CLASS_NAME_OPENED);

	const subscribeOnTransitionEnd = (onTransitionEnd) =>
		content.addEventListener(
			'transitionend',
			() => {
				onTransitionEnd();
				parent.classList.remove(CLASS_NAME_ANIMATED);
			},
			{
				once: true,
			}
		);

	const expand = () => {
		parent.classList.add(CLASS_NAME_OPENED);
		content.style.display = 'block';
		content.style.height = 'auto';

		const height = `${content.clientHeight}px`;

		content.style.height = '0';

		setTimeout(() => (content.style.height = height), 0);
		subscribeOnTransitionEnd(() => {
			content.style.height = 'auto';
		});
	};

	const collapse = () => {
		const height = `${content.clientHeight}px`;

		content.style.height = height;

		setTimeout(() => (content.style.height = '0'), 0);

		parent.classList.remove(CLASS_NAME_OPENED);

		subscribeOnTransitionEnd(() => {
			content.style.display = 'none';
		});
	};

	isOpened ? collapse() : expand();
};

export function isLoggedIn() {
	const session = sessionStorage.getItem('bd_cache')
	return session ? true : false
}